var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code-print-tpl"},[_c('p',{staticClass:"qr-tip"}),_c('div',{staticClass:"qr-box"},[_c('span',[_vm._v(_vm._s(_vm.clinicName))]),_vm._m(0),_c('span',[_vm._v("扫码一键寄送")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-code"},[_c('div',{attrs:{"id":"qrcodetpl"}})])
}]

export { render, staticRenderFns }